import { formatPrice } from 'lib/utils'
import { getInsuranceDisplay, getInsuranceTypeLabel } from '../bookingDetailHelpers'

/**
 * Standalone note shown when the insurance is collected at the office (company flag off).
 * In that case the amount is NOT part of the online payment total, so instead of a
 * misleading line item we render a separate badge stating what the customer owes at the office.
 */
const InsuranceOfficeNote = ({ bookingData, t }) => {
  const insurance = getInsuranceDisplay(bookingData)
  if (!insurance.collectAtOffice) return null

  return (
    <div className="w-full pt-1">
      <span className="inline-flex items-center rounded-full border border-amber-200/90 bg-gradient-to-r from-amber-100/95 to-amber-50/80 px-2.5 py-1 text-[11px] font-semibold leading-snug text-amber-800 ring-1 ring-amber-200/70 shadow-sm">
        {t('booking.orderSummary.insuranceOfficeNote', {
          type: getInsuranceTypeLabel(bookingData, t),
          amount: formatPrice(insurance.displayAmount, true),
          currency: t('common.omr'),
        })}
      </span>
    </div>
  )
}

export default InsuranceOfficeNote
